// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Category = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Category.purs");
var Control_Monad_Reader_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Reader/Trans.purs");
var Control_Monad_Writer = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer.purs");
var Data_Argonaut_Core = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/argonaut-core/v6.0.0/src/Data/Argonaut/Core.purs");
var Data_Array = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/arrays/v6.0.1/src/Data/Array.purs");
var Data_Bifunctor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/bifunctors/v5.0.0/src/Data/Bifunctor.purs");
var Data_Codec = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec/v4.0.1/src/Data/Codec.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Eq = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Eq.purs");
var Data_Function = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Function.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Generic_Rep = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Generic/Rep.purs");
var Data_Int = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/integers/v5.0.0/src/Data/Int.purs");
var Data_List_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/lists/v6.0.1/src/Data/List/Types.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Ord = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ord.purs");
var Data_Ordering = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ordering.purs");
var Data_Show = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Show.purs");
var Data_String_CodePoints = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/strings/v5.0.0/src/Data/String/CodePoints.purs");
var Data_String_CodeUnits = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/strings/v5.0.0/src/Data/String/CodeUnits.purs");
var Data_Symbol = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Symbol.purs");
var Data_Traversable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Traversable.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Data_Void = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Void.purs");
var Foreign_Object = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object.purs");
var TypeMismatch = (function () {
    function TypeMismatch(value0) {
        this.value0 = value0;
    };
    TypeMismatch.create = function (value0) {
        return new TypeMismatch(value0);
    };
    return TypeMismatch;
})();
var UnexpectedValue = (function () {
    function UnexpectedValue(value0) {
        this.value0 = value0;
    };
    UnexpectedValue.create = function (value0) {
        return new UnexpectedValue(value0);
    };
    return UnexpectedValue;
})();
var AtIndex = (function () {
    function AtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AtIndex.create = function (value0) {
        return function (value1) {
            return new AtIndex(value0, value1);
        };
    };
    return AtIndex;
})();
var AtKey = (function () {
    function AtKey(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AtKey.create = function (value0) {
        return function (value1) {
            return new AtKey(value0, value1);
        };
    };
    return AtKey;
})();
var Named = (function () {
    function Named(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Named.create = function (value0) {
        return function (value1) {
            return new Named(value0, value1);
        };
    };
    return Named;
})();
var MissingValue = (function () {
    function MissingValue() {

    };
    MissingValue.value = new MissingValue();
    return MissingValue;
})();
var showJsonDecodeError = new Data_Show.Show(function (v) {
    if (v instanceof TypeMismatch) {
        return "(TypeMismatch " + (Data_Show.show(Data_Show.showString)(v.value0) + ")");
    };
    if (v instanceof UnexpectedValue) {
        return "(UnexpectedValue " + (Data_Argonaut_Core.stringify(v.value0) + ")");
    };
    if (v instanceof AtIndex) {
        return "(AtIndex " + (Data_Show.show(Data_Show.showInt)(v.value0) + (" " + (Data_Show.show(showJsonDecodeError)(v.value1) + ")")));
    };
    if (v instanceof AtKey) {
        return "(AtKey " + (Data_Show.show(Data_Show.showString)(v.value0) + (" " + (Data_Show.show(showJsonDecodeError)(v.value1) + ")")));
    };
    if (v instanceof Named) {
        return "(Named " + (Data_Show.show(Data_Show.showString)(v.value0) + (" " + (Data_Show.show(showJsonDecodeError)(v.value1) + ")")));
    };
    if (v instanceof MissingValue) {
        return "MissingValue";
    };
    throw new Error("Failed pattern match at Data.Codec.Argonaut (line 73, column 10 - line 79, column 35): " + [ v.constructor.name ]);
});
var recordProp = function (dictIsSymbol) {
    return function (dictCons) {
        return function (p) {
            return function (codecA) {
                return function (codecR) {
                    var unsafeSet = function (key) {
                        return function (a) {
                            var $178 = Foreign_Object.insert(key)(a);
                            return function ($179) {
                                return $178($179);
                            };
                        };
                    };
                    var unsafeGet = function (s) {
                        var $180 = Data_Maybe.fromJust();
                        var $181 = Foreign_Object.lookup(s);
                        return function ($182) {
                            return $180($181($182));
                        };
                    };
                    var enc$prime = function (key) {
                        return function (val) {
                            return Control_Monad_Writer.writer(Data_Tuple.Tuple.create(val)(new Data_List_Types.Cons(new Data_Tuple.Tuple(key, Data_Codec.encode(codecA)(unsafeGet(key)(val))), Data_Codec.encode(codecR)(val))));
                        };
                    };
                    var dec$prime = function (key) {
                        return function (obj) {
                            return Control_Bind.bind(Data_Either.bindEither)(Data_Codec.decode(codecR)(obj))(function (r) {
                                return Control_Bind.bind(Data_Either.bindEither)(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(AtKey.create(key))((function () {
                                    var v = Foreign_Object.lookup(key)(obj);
                                    if (v instanceof Data_Maybe.Just) {
                                        return Data_Codec.decode(codecA)(v.value0);
                                    };
                                    if (v instanceof Data_Maybe.Nothing) {
                                        return new Data_Either.Left(MissingValue.value);
                                    };
                                    throw new Error("Failed pattern match at Data.Codec.Argonaut (line 269, column 31 - line 271, column 36): " + [ v.constructor.name ]);
                                })()))(function (a) {
                                    return Control_Applicative.pure(Data_Either.applicativeEither)(unsafeSet(key)(a)(r));
                                });
                            });
                        };
                    };
                    var key = Data_Symbol.reflectSymbol(dictIsSymbol)(p);
                    return new Data_Codec.GCodec(dec$prime(key), enc$prime(key));
                };
            };
        };
    };
};
var record = new Data_Codec.GCodec(Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Either.applicativeEither))({}), function (val) {
    return Control_Monad_Writer.writer(new Data_Tuple.Tuple(val, Data_List_Types.Nil.value));
});
var prop = function (key) {
    return function (codec) {
        var enc = function (val) {
            return Control_Monad_Writer.writer(new Data_Tuple.Tuple(val, Control_Applicative.pure(Data_List_Types.applicativeList)(new Data_Tuple.Tuple(key, Data_Codec.encode(codec)(val)))));
        };
        var dec = function (obj) {
            return Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(AtKey.create(key))((function () {
                var v = Foreign_Object.lookup(key)(obj);
                if (v instanceof Data_Maybe.Just) {
                    return Data_Codec.decode(codec)(v.value0);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return new Data_Either.Left(MissingValue.value);
                };
                throw new Error("Failed pattern match at Data.Codec.Argonaut (line 223, column 25 - line 225, column 34): " + [ v.constructor.name ]);
            })());
        };
        return new Data_Codec.GCodec(dec, enc);
    };
};
var prismaticCodec = function (name) {
    return function (f) {
        return function (g) {
            return function (orig) {
                return Data_Codec.basicCodec(function (json$prime) {
                    return Control_Bind.bindFlipped(Data_Either.bindEither)((function () {
                        var $183 = Data_Either.note(new Named(name, new UnexpectedValue(json$prime)));
                        return function ($184) {
                            return $183(f($184));
                        };
                    })())(Data_Codec.decode(orig)(json$prime));
                })((function () {
                    var $185 = Data_Codec.encode(orig);
                    return function ($186) {
                        return $185(g($186));
                    };
                })());
            };
        };
    };
};
var printJsonDecodeError = function (err) {
    var go = function (v) {
        if (v instanceof TypeMismatch) {
            return "  Expected value of type '" + (v.value0 + "'.");
        };
        if (v instanceof UnexpectedValue) {
            return "  Unexpected value " + (Data_Argonaut_Core.stringify(v.value0) + ".");
        };
        if (v instanceof AtIndex) {
            return "  At array index " + (Data_Show.show(Data_Show.showInt)(v.value0) + (":\x0a" + go(v.value1)));
        };
        if (v instanceof AtKey) {
            return "  At object key " + (v.value0 + (":\x0a" + go(v.value1)));
        };
        if (v instanceof Named) {
            return "  Under '" + (v.value0 + ("':\x0a" + go(v.value1)));
        };
        if (v instanceof MissingValue) {
            return "  No value was found.";
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 86, column 10 - line 92, column 45): " + [ v.constructor.name ]);
    };
    return "An error occurred while decoding a JSON value:\x0a" + go(err);
};
var jsonPrimCodec = function (ty) {
    return function (f) {
        return Data_Codec.basicCodec((function () {
            var $187 = Data_Maybe.maybe(new Data_Either.Left(new TypeMismatch(ty)))(Control_Applicative.pure(Data_Either.applicativeEither));
            return function ($188) {
                return $187(f($188));
            };
        })());
    };
};
var $$null = jsonPrimCodec("Null")(Data_Argonaut_Core.toNull)(Data_Function["const"](Data_Argonaut_Core.jsonNull));
var number = jsonPrimCodec("Number")(Data_Argonaut_Core.toNumber)(Data_Argonaut_Core.fromNumber);
var string = jsonPrimCodec("String")(Data_Argonaut_Core.toString)(Data_Argonaut_Core.fromString);
var $$void = jsonPrimCodec("Void")(Data_Function["const"](Data_Maybe.Nothing.value))(Data_Void.absurd);
var json = Data_Codec.basicCodec(Control_Applicative.pure(Data_Either.applicativeEither))(Control_Category.identity(Control_Category.categoryFn));
var jobject = jsonPrimCodec("Object")(Data_Argonaut_Core.toObject)(Data_Argonaut_Core.fromObject);
var object = function (name) {
    return Data_Codec.bihoistGCodec(function (r) {
        return Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
            var $189 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Named.create(name));
            var $190 = Control_Monad_Reader_Trans.runReaderT(r);
            return function ($191) {
                return $189($190($191));
            };
        })())(Data_Codec.decode(jobject));
    })(Control_Monad_Writer.mapWriter(Data_Bifunctor.rmap(Data_Bifunctor.bifunctorTuple)((function () {
        var $192 = Foreign_Object.fromFoldable(Data_List_Types.foldableList);
        return function ($193) {
            return Data_Argonaut_Core.fromObject($192($193));
        };
    })())));
};
var jarray = jsonPrimCodec("Array")(Data_Argonaut_Core.toArray)(Data_Argonaut_Core.fromArray);
var $$int = jsonPrimCodec("Int")(Control_Bind.composeKleisliFlipped(Data_Maybe.bindMaybe)(Data_Int.fromNumber)(Data_Argonaut_Core.toNumber))(function ($194) {
    return Data_Argonaut_Core.fromNumber(Data_Int.toNumber($194));
});
var indexedArray = function (name) {
    return Data_Codec.bihoistGCodec(function (r) {
        return Control_Bind.composeKleisliFlipped(Data_Either.bindEither)((function () {
            var $195 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Named.create(name));
            var $196 = Control_Monad_Reader_Trans.runReaderT(r);
            return function ($197) {
                return $195($196($197));
            };
        })())(Data_Codec.decode(jarray));
    })(Control_Monad_Writer.mapWriter(Data_Bifunctor.rmap(Data_Bifunctor.bifunctorTuple)((function () {
        var $198 = Data_Array.fromFoldable(Data_List_Types.foldableList);
        return function ($199) {
            return Data_Argonaut_Core.fromArray($198($199));
        };
    })())));
};
var index = function (ix) {
    return function (codec) {
        var enc = function (val) {
            return Control_Monad_Writer.writer(new Data_Tuple.Tuple(val, Control_Applicative.pure(Data_List_Types.applicativeList)(Data_Codec.encode(codec)(val))));
        };
        var dec = function (xs) {
            return Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(AtIndex.create(ix))((function () {
                var v = Data_Array.index(xs)(ix);
                if (v instanceof Data_Maybe.Just) {
                    return Data_Codec.decode(codec)(v.value0);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return new Data_Either.Left(MissingValue.value);
                };
                throw new Error("Failed pattern match at Data.Codec.Argonaut (line 194, column 26 - line 196, column 34): " + [ v.constructor.name ]);
            })());
        };
        return new Data_Codec.GCodec(dec, enc);
    };
};
var genericJsonDecodeError = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof TypeMismatch) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof UnexpectedValue) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof AtIndex) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
    };
    if (x instanceof AtKey) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)))));
    };
    if (x instanceof Named) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
    };
    if (x instanceof MissingValue) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))));
    };
    throw new Error("Failed pattern match at Data.Codec.Argonaut (line 70, column 1 - line 70, column 67): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new TypeMismatch(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new UnexpectedValue(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new AtIndex(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new AtKey(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new Named(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
        return MissingValue.value;
    };
    throw new Error("Failed pattern match at Data.Codec.Argonaut (line 70, column 1 - line 70, column 67): " + [ x.constructor.name ]);
});
var fix = function (f) {
    return Data_Codec.basicCodec(function (x) {
        return Data_Codec.decode(f(fix(f)))(x);
    })(function (x) {
        return Data_Codec.encode(f(fix(f)))(x);
    });
};
var eqJsonDecodeError = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof TypeMismatch && y instanceof TypeMismatch) {
            return x.value0 === y.value0;
        };
        if (x instanceof UnexpectedValue && y instanceof UnexpectedValue) {
            return Data_Eq.eq(Data_Argonaut_Core.eqJson)(x.value0)(y.value0);
        };
        if (x instanceof AtIndex && y instanceof AtIndex) {
            return x.value0 === y.value0 && Data_Eq.eq(eqJsonDecodeError)(x.value1)(y.value1);
        };
        if (x instanceof AtKey && y instanceof AtKey) {
            return x.value0 === y.value0 && Data_Eq.eq(eqJsonDecodeError)(x.value1)(y.value1);
        };
        if (x instanceof Named && y instanceof Named) {
            return x.value0 === y.value0 && Data_Eq.eq(eqJsonDecodeError)(x.value1)(y.value1);
        };
        if (x instanceof MissingValue && y instanceof MissingValue) {
            return true;
        };
        return false;
    };
});
var ordJsonDecodeError = new Data_Ord.Ord(function () {
    return eqJsonDecodeError;
}, function (x) {
    return function (y) {
        if (x instanceof TypeMismatch && y instanceof TypeMismatch) {
            return Data_Ord.compare(Data_Ord.ordString)(x.value0)(y.value0);
        };
        if (x instanceof TypeMismatch) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof TypeMismatch) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof UnexpectedValue && y instanceof UnexpectedValue) {
            return Data_Ord.compare(Data_Argonaut_Core.ordJson)(x.value0)(y.value0);
        };
        if (x instanceof UnexpectedValue) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof UnexpectedValue) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof AtIndex && y instanceof AtIndex) {
            var v = Data_Ord.compare(Data_Ord.ordInt)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(ordJsonDecodeError)(x.value1)(y.value1);
        };
        if (x instanceof AtIndex) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof AtIndex) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof AtKey && y instanceof AtKey) {
            var v = Data_Ord.compare(Data_Ord.ordString)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(ordJsonDecodeError)(x.value1)(y.value1);
        };
        if (x instanceof AtKey) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof AtKey) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Named && y instanceof Named) {
            var v = Data_Ord.compare(Data_Ord.ordString)(x.value0)(y.value0);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(ordJsonDecodeError)(x.value1)(y.value1);
        };
        if (x instanceof Named) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Named) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MissingValue && y instanceof MissingValue) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut (line 69, column 1 - line 69, column 57): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var codePoint = jsonPrimCodec("CodePoint")(Control_Bind.composeKleisliFlipped(Data_Maybe.bindMaybe)(Data_String_CodePoints.codePointAt(0))(Data_Argonaut_Core.toString))(function ($200) {
    return Data_Argonaut_Core.fromString(Data_String_CodePoints.singleton($200));
});
var $$char = jsonPrimCodec("Char")(Control_Bind.composeKleisliFlipped(Data_Maybe.bindMaybe)(Data_String_CodeUnits.toChar)(Data_Argonaut_Core.toString))(function ($201) {
    return Data_Argonaut_Core.fromString(Data_String_CodeUnits.singleton($201));
});
var $$boolean = jsonPrimCodec("Boolean")(Data_Argonaut_Core.toBoolean)(Data_Argonaut_Core.fromBoolean);
var array = function (codec) {
    var enc = function (xs) {
        return Control_Monad_Writer.writer(new Data_Tuple.Tuple(xs, Data_Argonaut_Core.fromArray(Data_Functor.map(Data_Functor.functorArray)(Data_Codec.encode(codec))(xs))));
    };
    var dec = function (j) {
        return Control_Bind.bindFlipped(Data_Either.bindEither)((function () {
            var $202 = Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither)(function (v) {
                return Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(AtIndex.create(v.value0))(Data_Codec.decode(codec)(v.value1));
            });
            var $203 = Data_Array.mapWithIndex(Data_Tuple.Tuple.create);
            return function ($204) {
                return $202($203($204));
            };
        })())(Data_Codec.decode(jarray)(j));
    };
    return new Data_Codec.GCodec(dec, enc);
};
module.exports = {
    TypeMismatch: TypeMismatch,
    UnexpectedValue: UnexpectedValue,
    AtIndex: AtIndex,
    AtKey: AtKey,
    Named: Named,
    MissingValue: MissingValue,
    printJsonDecodeError: printJsonDecodeError,
    json: json,
    "null": $$null,
    "boolean": $$boolean,
    number: number,
    "int": $$int,
    string: string,
    codePoint: codePoint,
    "char": $$char,
    jarray: jarray,
    jobject: jobject,
    "void": $$void,
    array: array,
    indexedArray: indexedArray,
    index: index,
    object: object,
    prop: prop,
    record: record,
    recordProp: recordProp,
    fix: fix,
    prismaticCodec: prismaticCodec,
    eqJsonDecodeError: eqJsonDecodeError,
    ordJsonDecodeError: ordJsonDecodeError,
    genericJsonDecodeError: genericJsonDecodeError,
    showJsonDecodeError: showJsonDecodeError,
    decode: Data_Codec.decode,
    encode: Data_Codec.encode
};

